/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { JasperServerDto } from './jasper-commercial.dto';
import { JasperServerMapper } from './jasper-commercial.mapper';

@Injectable()
export class JasperCommercialRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  turnOn(): Observable<JasperServerDto> {
    return this.httpGet(`${this.bp}/jc/on`, JasperServerMapper);
  }

  turnOff(): Observable<JasperServerDto> {
    return this.httpGet(`${this.bp}/jc/off`, JasperServerMapper);
  }

  status(): Observable<JasperServerDto> {
    return this.httpGet(`${this.bp}/jc/status`, JasperServerMapper);
  }
}
